module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781429996211_i0002.jpg",
      "src": "e9781429996211_i0002.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429996211_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACT ONE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429996211_toc01#toctitle3",
      "id": "title3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SCENE 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Stage dark. A television flickers on—a nature show: Africa, the Serengeti. Hyenas circle a dying gazelle. Lights up. Late afternoon.")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", somewhere between thirty and fifty years old, sits erect in an armchair on a city sidewalk, her back against an electronics store window, reading a newspaper. She is dressed in layers but not shabby. Her demeanor is somewhat haughty, almost imperious—the chair is her throne. The television is in the window, behind and slightly above her head. As")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("reads, the door to her right opens, and")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("steps out—mid-forties, suit jacket, jeans. He seems dazed, stares straight ahead. The door clicks shut behind him. He starts, pats his pocket for the key, turns and tries the door—door is locked. Checks his pockets for the key. No key. Pauses. Rubs temple. Puts hand on knob, gives it a good shake. Nothing. Tries harder, like opening a jar. Glances at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", who is seemingly focused on reading her newspaper.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("tries the knob delicately, like a safecracker. Nothing. Takes off his jacket, turns pockets inside out searching for key.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(",")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("glances at him.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gestures that he’s locked himself out.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("raises an eyebrow.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: I live here.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("shrugs.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("puts his coat back on, the pockets hanging out.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at the names on the bells. Looks at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: My name isn’t on the bell yet. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Scans names.")]), _vm._v(") This one should be me.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("From her chair,")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("squints at bells, clucks her tongue, goes back to her newspaper.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("tries door again, subtly presses shoulder against it.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("half watches over the top of newspaper, skeptical.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("takes doorknob in hand; kicks once, ineffectually, at bottom of door.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("leans away from door, then throws his shoulder against it. Door doesn’t budge.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("smiles, shakes head knowingly. Near defeat,")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("leans head wearily against the door, stares down length of the sidewalk, away from")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". As")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("speaks,")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("turns slowly to listen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("reading from newspaper, to no one in particular")]), _vm._v("): The question, turns out, is not why we sleep, but why we wake up. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Looks up matter-of-factly.")]), _vm._v(") Dreaming. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("To")]), _vm._v(" GIDEON) Dreaming is the more natural state—consciousness, this ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks around")]), _vm._v(") … this is unnatural.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("stares at her, failing to understand the significance.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("folds newspaper, slowly stands, moves to")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". He stiffens.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("taps his chest with the newspaper.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Scientifically there’s no reason to wake up.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Using the folded newspaper,")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("moves")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("a few inches away from bells, then looks at the names on bells for a moment, her finger hovering over them. She presses one, waits, listens. Nothing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: No one home.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: I live alone.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Is that how it is? ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Walks back to chair.")]), _vm._v(") Nice to have the place to yourself. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sits, looks at")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("intently.")]), _vm._v(") You can walk around naked.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v("’s eyes widen.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("opens newspaper.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at bells.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: I’ll ring my neighbor. We pass each other in the hall. We’ve never spoken …")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Neighbors can be good. But you should be careful.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". Looks at bells. Rings a bell. Waits. He is about to ring again when intercom speaks, nearly unintelligible.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM: Whoizit?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Hi, uh. I live in the apartment beside you. I’ve locked myself out. Apartment thirteen.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM: ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Unintelligible static.")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Silence.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("hesitates, then rings again.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Do you think you could buzz me in?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Silence. Reluctantly he rings the bell again. Intercom clearer now, annoyed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM: What?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Could you buzz me in? I’ve locked myself out. If I could use your phone …")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("nearly unintelligible")]), _vm._v("): Jesus H. Christ.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("As intercom speaks, the door buzzes for a second.")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", surprised, lurches toward it, but too late.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("glances at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". Rubs temple. Looks at bells again. Straightens himself. Presses bell.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Sorry. I missed it that time. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Beat.")]), _vm._v(") I’m not feeling well. I wonder if you could buzz me in again?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Silence.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("shakes head knowingly. On the television, a million wildebeests migrate northward.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("stands, moves beside")]), _vm._v(" GIDEON.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: You gotta be careful with neighbors. They can turn on you. (ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("squares shoulders, rings bell, hisses softly into mouthpiece.")]), _vm._v(") You have to come out sometime, bitch.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks aghast.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sits back down, takes off her shoes, rubs feet.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: I had a neighbor like that.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("straightens his jacket collar.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Behind on the rent?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("shakes head. Notices his pockets turned inside out, tucks them in.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: That’s how it starts—show up late a few times, get the sack, the money dries up …")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Money is not a problem.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("takes out wallet, pulls out a credit card, shows it to")]), _vm._v(" ALICE.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at door, looks at card, tries to jimmy door with card.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Not a problem at all. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Card snaps in half.")]), _vm._v(") Goddammit.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: That’s a good lock on that door, as I recall. Does what you want a lock to do.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("glares at her.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Beg, borrow, get someone else to pay, you have to keep up on the rent.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Listen, I’m not behind on the rent. I’ve locked myself out.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: I don’t see you heading off to work every morning. Not lately.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: That’s … temporary. I’m between things. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Flutters hand vaguely up at building.")]), _vm._v(") Working at home for now.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("holds up newspaper")]), _vm._v("): Me too.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("almost smiles.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Do you know the landlord’s name? The woman we’re subletting from never told me.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Oh, I wouldn’t do that. Tell the landlord? What’s to keep him from sliding someone else in?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("considers this.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("pulls a cell phone from the chair cushions, holds it casually up to")]), _vm._v(" GIDEON.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Why don’t you call a locksmith?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks dubiously at the cell phone.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks more intently at")]), _vm._v(" GIDEON): I found it in the park.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("shakes his head slightly, turns away, leans his head against the door.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Blackout.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429996211_toc01#toctitle4",
      "id": "title4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SCENE 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Lights up. Morning. Television off.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("is squeezed in beside")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("on the chair, asleep with his head on her shoulder. His suit collar is turned up, his hair disheveled.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("is reading a book. As")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("reads,")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("slowly wakes up, realizes he’s been leaning on her. Embarrassed, he straightens himself but remains sitting beside her. A box of donuts is balanced on the arm of the chair beside")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v("—she\ntakes one. She comes upon a passage in the book, eats donut as she speaks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("musing")]), _vm._v("): Straw to a drowning man. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Straw")]), _vm._v(" to a drowning man. A drowning man. A man drowning. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Beat.")]), _vm._v(") I’ve never been able to wrap my mind around that one—You see a man drowning, you throw him a straw. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Beat.")]), _vm._v(") What exactly does the drowning man do with the straw? I mean, does he use it like a snorkel, to breathe underwater? Does he simply hold on to it, like a tiny life raft—Hey, drowning guy, grab onto this, a thousand more and you got yourself a boat. Does he use it to drink the ocean or puddle or whatever it is he’s drowning in, thus hurrying his demise, ending his misery? Is it the same straw that broke the camel’s back, the proverbial “last straw,” that last little bit which somehow pulls him under? ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Looks at")]), _vm._v(" GIDEON.) What kind of straw are we talking about here?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". He stands, looks around, still groggy. Phone rings.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks around for source of sound.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("pulls cell phone from chair cushions, opens it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Who? He’s not here. What? "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Your")]), _vm._v(" phone? How do I know that? ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Closes phone, then speaks to audience.")]), _vm._v(") Straw. I mean, you’re close enough to hand him a straw, or a piece of straw, why don’t you take his hand and pull him out?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: That phone works?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: I told you. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Takes another donut from the box, offers it in an offhand way.")]), _vm._v(") You hungry?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: No. Could I … ?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("passes")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("the phone. He turns it over suspiciously in his hand, opens it, dials 411, listens.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: It’s got no credit.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("dawns on her")]), _vm._v("): Incoming. Try collect.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("closes phone, hands it back to")]), _vm._v(" ALICE. ESRA"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", a fifteen-year-old girl, rides up on a foot-propelled scooter. She parks it, goes to bells, rings one, waits. Looks up at building. Tries door. Turns to")]), _vm._v(" ALICE.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA: Power’s out. School told us to go home. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Beat.")]), _vm._v(") Have you seen my mom?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Power’s out?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("ignores")]), _vm._v(" GIDEON—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("to")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", with playful urgency")]), _vm._v("): This morning, in the playground, millions of business guys were sleeping beneath the jungle gyms. In suits! They looked laminated.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Your mom’s not back yet.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA: Figures.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("dawns on her")]), _vm._v("): The trains, listen—they’re dead.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("All cock their heads, listen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Why, when the power fails, do trains stop running? Since when do trains need light to move? I thought they made their own light.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: You’re the girl who lives next door. I don’t suppose you could let me use your phone? I’ve locked myself out.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA: Next door?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: To me. I live in thirteen.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA: Agnes lives in thirteen.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: He’s behind on the rent.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: I’m not behind on the rent. I’m … we’re … subletting from Agnes.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: I thought you lost your job?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("to")]), _vm._v(" ALICE): I’ve just locked myself out. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("To")]), _vm._v(" ESRA) Look, I know you can’t just let a strange man inside your building, but if your mother is home, could you ask her to buzz me in?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("and")]), _vm._v(" ESRA "), _c('em', {
    staticClass: "i"
  }, [_vm._v("look at each other, laugh.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Her mother isn’t home.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("to")]), _vm._v(" ALICE): If you see my mom, will you tell her I was here?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE: Sure, sweetie. Take a donut.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ESRA "), _c('em', {
    staticClass: "i"
  }, [_vm._v("takes a donut, fetches scooter, rides off.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks up at sky, hunches shoulders, turns up his jacket collar.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Looks like rain. Looks like it’s gonna pour. What do we do when it rains?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("still watching")]), _vm._v(" ESRA "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ride away")]), _vm._v("): It’ll pass right over us.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("considers this, looks doubtfully at the sky; turns toward television, though it is dead.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("teasingly ominous")]), _vm._v("): Maybe soon it’ll be your clothes, raining down. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Puts hands playfully over her head.")]), _vm._v(") I better watch out. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("More seriously")]), _vm._v(") What’d she do, toss you out? ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Beat.")]), _vm._v(") Happened to me. My husband, we’d fight all the time—I couldn’t promise I’d meet him in eternity. Eternity! Ha!")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sighs heavily but doesn’t respond. The television flickers on—Africa, tribal dancing.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("stares at it. Looks down at")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". At donuts.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("goes to bells. Rings them all. A voice comes over the intercom.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM: Yes?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Gas man.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM: What?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: Gas man. Here to check the meters.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("INTERCOM: Jesus H. Christ.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("The door buzzes,")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("pulls it open; steps inside; looks down at")])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", slightly pained; shrugs; lets it close behind him. Television flickers off.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Blackout.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429996211_toc01#toctitle5",
      "id": "title5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SCENE 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Stage dark. Television flickers on—Africa. A lion watches the wildebeest migration. Lights up. Morning.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("is standing, facing window,\nwatching television. The door is propped open with his jacket.")]), _vm._v(" IVAN"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", mid-thirties, is lying facedown on the sidewalk about five feet away, wearing an expensive suit.")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("is nowhere to be seen. The box of donuts sits where")]), _vm._v(" ALICE "), _c('em', {
    staticClass: "i"
  }, [_vm._v("had been sitting, the words DROWNING? FREE STRAWS written on the open lid.")]), _vm._v(" IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("rouses himself and stands, stretching.")]), _vm._v(" IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sees")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", sizes him up, walks over, stands close. Speaks while half watching television.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Wildebeests. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Glances at")]), _vm._v(" GIDEON—"), _c('em', {
    staticClass: "i"
  }, [_vm._v("no response.")]), _vm._v(") Three million stumbling north for the last mouthful of grass. The lions, they reach in, pluck ’em like daisies. Like after-dinner mints.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("half glances at")]), _vm._v(" IVAN"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", then back to television.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Three years ago, I spent a week on safari. The Serengeti. Ngorongoro. A week under the stars with a .45 under my head. Hadn’t slept outside since. Feels good. Alive.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("No response from")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v(".")]), _vm._v(" IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("leans in closer, lowers voice.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: One morning, I’m pissing in a river—this crocodile, he’s eating a zebra, not five feet from my boot. He’s stripped the whole body clean, but the head, the head’s giving him trouble.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("half glances at")]), _vm._v(" IVAN"), _c('em', {
    staticClass: "i"
  }, [_vm._v(", leans slightly away.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: He keeps gnawing at it but he can’t make any progress.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("No response from")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: The head was too big. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Realizes television is on, points to it.")]), _vm._v(") Hey, the power’s back.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: It’s been flickering all night. Impossible to sleep.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: I can sleep through anything. What time is it?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks up at sky")]), _vm._v("): Almost seven, I’d guess.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Trains running? You headed downtown?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: No. I live here.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Serious? ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Taps")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("on shoulder, points to door.")]), _vm._v(") Let me use your bathroom. I gotta clean up.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: I’m locked out.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("indignant snort")]), _vm._v("): Come on.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: No, really.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("annoyed")]), _vm._v("): You got electric locks or something? ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Shakes head, laughs.")]), _vm._v(") Shit, to be stuck outside your own fucken door all night. I thought I had it bad. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Beat. Holds out hand to")]), _vm._v(" GIDEON.) Ivan.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at hand, takes it briefly")]), _vm._v("): Gideon.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("notices box of donuts, nods toward it")]), _vm._v("): Yours?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks at donuts.")]), _vm._v(" IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("takes a donut.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: You mind?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("takes bite of donut. They look at television.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Fucken Africa. It’s a cartoon world down there, everything the wrong size—the leaves, the trees, the bugs. Bigger than life.\nEverywhere you turn, you think, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("That")]), _vm._v(" could kill me, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("that")]), _vm._v(" could kill me. The water, a cut on your knee, a mosquito. The sun, my God, the sun. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Points to")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v("’s face.")]), _vm._v(") It’s the things you can’t see that’ll get you. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Musing, takes bite of donut.")]), _vm._v(") I felt so hungry all the time, like "), _c('em', {
    staticClass: "i"
  }, [_vm._v("I")]), _vm._v(" was the one starving. Nothing but rice and sauce, rice and sauce, Jesus Christ, I’d shovel it in. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Takes bite of donut.")]), _vm._v(") Must have gained ten fucken pounds.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("looks briefly up and down")]), _vm._v(" IVAN"), _c('em', {
    staticClass: "i"
  }, [_vm._v("’s body.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: You wouldn’t have a phone I could use?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("comes out of his reverie, looks at")]), _vm._v(" GIDEON): A phone?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: I need to call a locksmith.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Maybe there’s an open window out back. I could give you ten fingers.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: An open window?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("steps back, looks up at building")]), _vm._v("): Or if we could get onto the roof, I could tie a rope around you, lower you down.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON: You don’t have a phone?")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Ran out of juice last night. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Points to television.")]), _vm._v(") But the power’s back.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("pushes last of donut into his mouth while looking at")]), _vm._v(" GIDEON"), _c('em', {
    staticClass: "i"
  }, [_vm._v(". Wipes mouth with sleeve.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: I have to get downtown. Gideon, it’s been good talking to you. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sincerely")]), _vm._v(") It helps.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("GIDEON ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("confused")]), _vm._v("): Sure.")])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("offers")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("his fist for fist bumps.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("tentatively fist-bumps.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN: Don’t let them muscle you, brother.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("IVAN "), _c('em', {
    staticClass: "i"
  }, [_vm._v("straightens his tie in the window, wanders off.")]), _vm._v(" GIDEON "), _c('em', {
    staticClass: "i"
  }, [_vm._v("moves to")]), _vm._v(" ALICE"), _c('em', {
    staticClass: "i"
  }, [_vm._v("’s chair, picks up box of donuts, sits, turns box over in his hands. A shirt flutters down on his head, followed by another, followed by a duffel bag, which thumps onto the ground beside him.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Blackout.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32dcbd12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429996211_c01.vue
// module id = 69
// module chunks = 0